import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createUser } from "../Features/users/userslice";
import "../Designs/designs.css";
import { NavLink } from "react-router-dom";
import { BiRightArrow } from "react-icons/bi";

const UserLogin = () => {
  const [userInput, setUserInput] = useState("");
  const moviesInfoUser = useSelector((state) => state.users.username);
  const dispatch = useDispatch();

  // if (userInput.length >= 10) {
  //   alert("you have reached max character limit");
  // }

  function handleClick(e) {
    e.preventDefault();
    // if (!moviesInfoUser) return;
    dispatch(createUser(userInput));
  }

  return (
    <div className="user-page-container">
      <header className="header">
        <div className="logo-ham">
          <div className="logo">
            <NavLink className="logo-name" to="/">
              Movies<span className="info">Info</span>
            </NavLink>
          </div>
        </div>
      </header>
      <div className="user-form-box">
        <p className="start-exploring-title">
          Unlimited Movies & TV Shows: <span>Your Endless Escape!</span>
        </p>
        <form onSubmit={handleClick}>
          <div className="input_and_btn">
            <input
              className="search_field"
              type="text"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              required
              placeholder="Enter Username (max: 10 chars)"
              maxLength="10"
            />
            <button className="search_btn">
              Get Started
              <span>
                <BiRightArrow />
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserLogin;
